export interface AirportContractListAttachmentRecord {
    id: number; 
    originalFileName: string;
    uploadTimestamp: Date;
    userName: string;
}